// extracted by mini-css-extract-plugin
export default {"contentWrapper":"ContentWrapper_contentWrapper__Ono9k"};